module.exports = __webpack_public_path__ + "img/antes_despues_297.f95a1773.png";